/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlOrderDir = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ControlOrderDir = typeof ControlOrderDir[keyof typeof ControlOrderDir];


export function ControlOrderDirFromJSON(json: any): ControlOrderDir {
    return ControlOrderDirFromJSONTyped(json, false);
}

export function ControlOrderDirFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlOrderDir {
    return json as ControlOrderDir;
}

export function ControlOrderDirToJSON(value?: ControlOrderDir | null): any {
    return value as any;
}

